import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export type TrackDisabledSelectAllParams = {
  trigger:
    | 'action-bar'
    | 'item-click'
    | 'escape'
    | 'navigation'
    | 'move'
    | 'drag'
    | 'mouse-selection'
    | 'item-unselect';
  totalSelectionCount: number;
};

export const useTrackDisabledSelectAll = () => {
  const { track } = useAnalyticsUtilities();

  const trackDisabledSelectAll = useCallback(
    (params: TrackDisabledSelectAllParams) => {
      track('disabled_select_all', params);
    },
    [track],
  );

  return { trackDisabledSelectAll };
};
